import { useEditorStore } from '@/features/editor/stores/mobx/editor-store';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { NumberField } from '@/components/number-field/number-field';
import { FormattedMessage } from 'react-intl';

export const EsdecRafterDistanceInput = observer(function EsdecRafterDistanceInput({
  surfaceId
}: {
  surfaceId: string;
}) {
  const store = useEditorStore();
  const { surfacesEsdec } = store;

  const surfaceEsdec = surfacesEsdec.surfaces[surfaceId];

  if (!surfaceEsdec) {
    return <React.Fragment />;
  }

  return (
    <NumberField
      isDisabled={surfaceEsdec.isRoofFinalized}
      minValue={450}
      label={<FormattedMessage defaultMessage="Rafter Distance" id="1lpUIj" />}
      formatOptions={{
        style: 'unit',
        unit: 'millimeter'
      }}
      showStepper={true}
      value={surfaceEsdec.rafterDistance}
      onChange={(value) => {
        if (Number.isNaN(value)) {
          return;
        }
        surfaceEsdec.updateRafterDistance(value);
      }}
    />
  );
});
